import { Badge } from '@purpur/library';
import styled from 'styled-components';

import { defaultLinkStyle } from '@telialt/common-theme/src/mixins';
import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const ContentCardWrapper = styled.article`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('50')};
`;

export const CategoryWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${getPurpurSpacing('50')};
    flex-wrap: wrap;
    min-height: 1.375rem;
`;

export const StyledBadge = styled(Badge)`
    margin-right: ${getPurpurSpacing('50')};
`;

export const StyledLink = styled.a`
    ${defaultLinkStyle()};
    font-weight: ${getPurpurTypography('weightMedium')};
`;

export const DescriptionWrapper = styled.div`
    color: ${getPurpurColor('gray700')};
    font-size: ${getPurpurTypography('scale75')};

    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    max-height: 5.25rem;
    text-overflow: ellipsis;

    ${purpurMedia('lg')`
        max-height: 2.625rem;
        -webkit-line-clamp: 2;
    `};
`;
